import { render } from "./PrimaryHeader.vue?vue&type=template&id=37cacab2&scoped=true&ts=true"
import script from "./PrimaryHeader.vue?vue&type=script&lang=ts"
export * from "./PrimaryHeader.vue?vue&type=script&lang=ts"

import "./PrimaryHeader.vue?vue&type=style&index=0&id=37cacab2&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37cacab2"]])

export default __exports__